import React from 'react';
import './index.css';
import logo from './logo.svg';

const State = () => {
  return (
    <div className="container">
      
      {/* Background Glow */}
      <div className="bg-animation"></div>

      {/* Rotating React Logo */}
      <img src={logo} alt="React Logo" className="logo" />

      {/* Main Content */}
      <h1 className="title">Website Under Construction </h1>

      <p className="subtitle">
        We are working hard to make this website amazing. <br />
        Please visit again soon ✨
      </p>

      <button className="btn">Coming Soon</button>
    </div>
  );
};

export default State;